<template>
  <div id="main-app" class="container">



    <div class="topheader topheaderheight">

      <div class="container">
          <div class="loupeheaderlogo">
            <p class="logotxt">LOUPE</p>
          </div>

        <div class="d-flex justify-content-center align-items-center topheaderheight pagetitle">
          <h3>Customer Reviews</h3>
        </div>
      </div>

    </div>



    <div class="container maincontent">

      <div class="row">

        <div class="col-lg-5 leftcontent" style="opacity:0;">
            <store-selection class="storeselector" v-if = "overallData.organization" :overallData = "overallData" :gApiLoaded = "gApiLoaded" @storeissselected = "storeissselected" @reviewisselected = "reviewisselected"></store-selection>
        </div>

        <div class="col-lg-7">
            <result-with-filter v-if = "storeSelected.loupeid" :storeSelected = "storeSelected" :reviewSelected = 'reviewSelected'></result-with-filter>
            
            <div v-if = "totalCountOfResultsDisplayedInResultComponenet > 3 && showResultMainContent && scrollTopSpace > 200" class="d-flex justify-content-end align-items-end" style="position:relative;">
               <div class="" style="position:fixed; bottom:20px;">
                  <a @click.stop.prevent="scrollTop" href="BackToTop" class="backtotopA">
                  <div class="mx-auto backtotopbtn"></div>
                  <!-- <p class="small p-0 m-0">Back to Top</p> -->
                  <img style="position:absolute; top:16px; left:7px; width:28px;" class="droparrow" src="builds/l_up_arrow.svg" alt="drop arrow">


                  </a>
               </div>
            </div>

        </div>

        
       

      </div>

    </div>
     

    <div class="footer mx-auto small m-5 ">
       <p class="color2">All reviews submitted by actual Apex Energy Solutions customers through the LOUPE SSG Platform.</p>
       <p class="font-weight-bold">Powered by LOUPE®</p>
       <p class="lastline">©2018 Touchstone Media Group, LLC</p>
    </div>
    

  </div>
</template>

<script>


import moment from 'moment';
import StoreSelection from './StoreSelection.vue';
import ResultListWithFilter from './ResultListWithFilter.vue';
import {apiURLBase} from './constants.js';


export default {
  name: 'MainApp',
  data() {
    
    return {
      overallData: {},
      storeSelected :{},
      reviewSelected :'',
      totalCountOfResultsDisplayedInResultComponenet:0,
      showResultMainContent: false,
      gApiLoaded: false,
      scrollTopSpace: 0,
    }
  }, //data
  components: {
    'store-selection': StoreSelection,
    'result-with-filter': ResultListWithFilter
  },//components
  methods : {
    storeissselected(v){
      this.storeSelected = v;
      
    },
    reviewisselected(v){
      this.reviewSelected = v;
    },

    scrollTop(){
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      // console.log(ResultListWithFilter.data());
    },


  },//methods
  created: function() {

     
            

  }, //created

  mounted: function (){

        const self = this;

          $(window).scroll(function() {
            self.scrollTopSpace = $(window).scrollTop();
          });


    this.$root.$on('totalResultDisplayed', (totalCount, showRMContent) => {
        this.totalCountOfResultsDisplayedInResultComponenet = totalCount;
        this.showResultMainContent = showRMContent;
      });
      
    this.$root.$on('gApiLoaded', () => {
        this.gApiLoaded = true;
        if (apiURLBase == 'loupedev'){
          console.log('######### 1. gapiloaded in vue recieved ######', this.gApiLoaded);
        }
      });


      TweenMax.staggerFrom(['.topheader', '.loupeheaderlogo', '.logotxt',], 0.8, {delay:0.5, opacity:0, y:'-=140', ease:Expo.easeOut}, 0.1);
      TweenMax.from('.loupeheaderlogo', 2, {delay:0.5, scale:3, rotation:-15, ease:Expo.easeOut});
      TweenMax.from('.pagetitle', 2, {delay:1, x:'+=20', y:'-=10', scale:1.3, opacity:0, ease:Expo.easeOut});


      TweenMax.from('.footer',1.1,{delay:0.7, y:'-=220', opacity:0, ease:Expo.easInOut, onComplete:function(){$('.footer').removeAttr('style');}});
      TweenMax.delayedCall(1.2,startAppHandler);



      function startAppHandler(){
        // return;
        const url = 'https://s3.amazonaws.com/reviews.json.' + apiURLBase + '.com/overall.json?' + new Date().getTime();
        
        if (apiURLBase == 'loupedev'){
          console.log('App Overall call: ', url);
        }

        $.ajax({
          url: url,
          success: function(data)
            {

              
              self.overallData = data;
              // console.log(self.overallData);
              
              TweenMax.to('.leftcontent', 1, {opacity:1,  ease:Expo.easInOut});


              
            },
            error: function (error){
              // console.log("error", error);
            }
        });


      }

  }, //mounted


  
} //default







</script>






<style>
.mesvg1{
  background-image: url("./assets/l_up_arrow.svg");
}


.topheaderheight{
  height:75px;
}
.topheader{
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1030;
  background-color: #16191f;
  color: white;
}
.maincontent{
  margin-top:75px;
}

.loupeheaderlogo{
  color: #d3d5d7;
  margin-top:10px;
  float:left;
  width:55px;
  height:65px;
  background-image: url("./assets/loupelogogrey.png");
  background-repeat: no-repeat;
  background-size: 55px 55px;
}
.logotxt{
  padding-left:75px;
  padding-top:10px;
  color:#d3d5d7;
  font-size: 2.75rem;
}


.vhheight{
  height:100vh;
}

.leftcontent{
  min-height: 500px;
  z-index: 1 !important;

}


.footer{
  border-top: 1px solid #9a9c9f;
  color:#16191f;
  width:80%;
  text-align: center;
  padding-top:40px;
}
.lastline{
  margin-top:-15px;
  color:#1c2025;
}



 .storeselector{
    position:fixed;
  }
  

@media (max-width: 540px) {
 .topheader{
    position:static;
    padding-top: 18px;
    margin-left: -15px;
    margin-right: -15px;
  }
  .maincontent{
    margin-top:0px !important;
  }
  .loupeheaderlogo{
    margin-top:0px !important;
  }
  
}

@media (max-width: 992px) {

 .storeselector{
    position:static;
  }
}

@media (max-width: 767.98px) {
 
  
 
  .loupeheaderlogo{
    float:none;
    margin:0 auto;
    margin-top:20px;
  }
  .logotxt{
    display:none;
    color:#d3d5d7;
  }
  .topheader{
    height:125px;
  }
 .maincontent{
   margin-top:125px;
  }
  
  .pagetitle{
    height:40px;
  }

  .footer{
    padding-top: 40px;
    width:80%;
    text-align: center;

  }
 }
  
  .backtotopbtn{
    
    background-color:#aaacaf;
    width:60px;
    height:60px;
    border-radius: 30px;
  }
  
  .backtotopA{
    text-decoration: none!important;
  }

  .backtotopA:hover .backtotopbtn{
    background-color:#9d9fa2;
  }



</style>



// WEBPACK FOOTER //
// App.vue?bf74fc00